import api from '../api';
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import '../scss/pages/Create.scss';
import CopyToClipboard from 'react-copy-to-clipboard';
import Lottie from 'react-lottie-player';
import noInterviews from '../animations/noInterviews.json';
import Loader from './Loader';
import { titles } from './jobtitles.mjs';
import Select from 'react-select'


export default function FirstPage({user}) {
    const [jobTitle, setJobTitle] = useState('');
    const [jobDescription, setJobDescription] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [addModal, setAddModal] = useState(null);
    const [usersCanSeeAnswers, setUsersCanSeeAnswers] = useState(false);
    const [userCanVoteMultipleTimes, setUserCanVoteMultipleTimes] = useState(user.user.accountType === 'individual' ? true : false);
    const [interviews, setInterviews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [jobTitleOptions, setJobTitleOptions] = useState([]);

    const navigate = useNavigate();

    const getInterviews = () => {
        setLoading(true);
        api.getInterviews(user.token)
        .then((data) => {
            const tmp = data.map((interview) => interview);
            setInterviews(tmp);
        })
        .catch((err) => {
            console.error(err);
        })
        .finally(() => {
            setTimeout(() => setLoading(false), 1000 )
        })
    }
    function submit(event){
        event.preventDefault();
        if(jobTitle?.value === ''){
            setErrorMessage('You need to provide a job title to continue');
        }else{
            setErrorMessage('');
            const randomId = Math.floor(Math.random() * 100000);
            const objectValue = {
                jobTitle: jobTitle.value,
                jobDescription: jobDescription,
                soft: [],
                hard:[],
                selectedSoftSkills: [],
                selectedHardSkills: [],
                softQuestions: [],
                hardQuestions: [],
                selectedSoftQuestions: [],
                selectedHardQuestions: [],
                interview_id: null,
                usersCanSeeAnswers: usersCanSeeAnswers,
                userCanVoteMultipleTimes: userCanVoteMultipleTimes
            }
            const valueString = JSON.stringify(objectValue);
            localStorage.setItem(randomId, valueString);
            setTimeout(() => {
                navigate(`/create/${encodeURIComponent(randomId)}`);
            }, 300)
        }
    }
    useEffect(() => {
        const o = titles.map((title) => {
            return {
                label: title,
                value: title
            }
        })
        setJobTitleOptions(o);
        getInterviews();
    }, [])
    const handleInputChange = (inputValue) => {
        // Check if the inputValue already exists in options
        const existingOption = jobTitleOptions.find(
            (option) => option.label.toLowerCase() === inputValue.toLowerCase()
        );

        // If the inputValue does not exist, create a new option
        if (!existingOption && inputValue.trim() !== '') {
            const newOption = {
                value: inputValue.toLowerCase(),
                label: inputValue,
            };

            // Set the new options list including the new option
            setJobTitleOptions([...jobTitleOptions, newOption]);
        }
    };
    return(
        <>  
            <div className="create__page">
                {!loading && 
                    <>
                        <div className="flex flex__row">
                            <button className="btn btn__primary" onClick={() => setAddModal(true)}>
                                <span className="material-icons">
                                    add
                                </span>
                                Create Interview
                            </button>
                            <div className="float--right flex flex__row">
                                <div className="btn btn__secondary-outline">
                                    {interviews.length} Items
                                </div>
                            </div>
                        </div>
                        <div>
                            {interviews.map((interview, idx) => {
                                return (
                                    <div key={`interview_${idx}`} className='card interview__item'>
                                        <h4 className='font1'>{interview.job_title}</h4>
                                        <div>
                                            {interview.job_description}
                                        </div>
                                        <div className="mtop__20 flex flex__row">
                                            <div>
                                                <button className='btn btn__secondary-outline btn__sm font__13' onClick={() => navigate(`/evaluations/${interview.id}`)}>
                                                    View evaluations
                                                </button>
                                                <button className='btn btn__primary-soft btn__sm font__13' onClick={() => navigate(`/answers/${interview.id}`)}>
                                                    Answer yourself
                                                </button>
                                                <CopyToClipboard text={`${window.location.origin}/answers/${interview.id}`}>
                                                    <button className='btn btn__secondary-outline btn__sm'>
                                                        <span className="material-icons font__16">
                                                            content_copy
                                                        </span>
                                                    </button>
                                                </CopyToClipboard>
                                            </div>
                                            <div className="float--right">
                                                <b>{interview.evaluations}</b> Response{interview.evaluations === 1 ? '' : 's'}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            {interviews.length === 0 && 
                                <div className="text__center">
                                    <Lottie
                                        loop={true}
                                        animationData={noInterviews}
                                        play
                                        style={{ width: 200, height: 200, margin: 'auto' }}
                                    />
                                    <h3>No interviews yet.</h3>
                                </div>
                            }
                        </div>
                    </>
                }
                {loading && <Loader />}
            </div>
            {addModal &&
                <div className="modal__overlay active">
                    <div className="modal active animate__animated animate__fadeIn">
                        <div className="modal__header">
                            <div className="modal__header-title">
                                <h3>Create New Interview</h3>
                            </div>
                            <div className="close-modal modal--x" onClick={() => { setAddModal(false) }}>
                                <svg viewBox="0 0 20 20">
                                    <path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
                                </svg>
                            </div>
                        </div>
                        <div className="modal__content">
                            <div className="modal__body">
                                <form
                                    onSubmit={(e) => submit(e)}
                                    method='post'
                                    className='card w__100'
                                >
                                    <div className="form__group text__left">
                                        <h5>Enter a job title or choose one from below</h5>
                                        <Select
                                            options={jobTitleOptions}
                                            onInputChange={handleInputChange}
                                            getOptionValue={(option) => option.value}
                                            getOptionLabel={(option) => option.label}
                                            isCreatable
                                            onChange={(selectedOption) => setJobTitle(selectedOption)}
                                            value={jobTitle}
                                         />
                                    </div>
                                    <div className="form__group text__left">
                                        <h5>Enter the job description</h5>
                                        <div className="input__wrap">
                                            <textarea
                                                type="text"
                                                value={jobDescription}
                                                placeholder="Type a description.."
                                                onChange={e => setJobDescription(e.target.value)}
                                            />
                                            <span className="focus"></span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <input type="checkbox" className="" checked={usersCanSeeAnswers} onChange={(e) => setUsersCanSeeAnswers(e.target.checked)}></input>
                                        <label>Users can see their results after completing the interview?</label>
                                    </div>
                                    <div className="mtop--20">
                                        <input type="checkbox" className="" checked={userCanVoteMultipleTimes} onChange={(e) => setUserCanVoteMultipleTimes(e.target.checked)}></input>
                                        <label>Users can answer the interview multiple times</label>
                                    </div>
                                    <button className="btn btn__primary btn__100 mtop--20" disabled={!jobTitle}>
                                        Generate
                                    </button>
                                    <div className='text__danger'>{errorMessage}</div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}